module.exports = __webpack_public_path__ + "img/image_jigou.3d755a98.png";